!<!--  -->
<template>
  <div class="">
    <div @click="goBack" style="cursor: pointer">
      <i class="el-icon-arrow-left"></i> <span>返回</span>
    </div>
    <div style="margin: 10px 20px">
      <el-card style="padding-bottom: 40px">
        <div>
          <span
            style="
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              line-height: 51px;
            "
            >帐单号：{{ basicData.billNo }}</span
          >
          <span style="width: 50px; display: inline-block"></span>
          <span
            style="
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              line-height: 51px;
            "
            >支付金额：{{ basicData.amount }} {{ basicData.currency }}</span
          >
          <div></div>
          <!-- 支付完成状态显示 -->
          <span
            v-if="basicData.state == 'S'"
            style="
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              line-height: 51px;
            "
          >
            支付时间：{{ basicData.payTime }}</span
          >
          <span style="width: 50px; display: inline-block"></span>
          <span
            v-if="basicData.state == 'S'"
            style="
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              line-height: 51px;
            "
          >
            支付方式：{{
              basicData.payType == "A" ? "支付宝支付" : "微信支付"
            }}</span
          >
        </div>

        <el-table
          :data="pageList"
          :header-cell-style="{
            background: '#eef1f6',
            color: '#606266',
          }"
          border
          align="center"
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column align="center" width="60" type="index" label="序号">
          </el-table-column>
          <el-table-column align="center" prop="nos" label="运单号">
          </el-table-column>
          <el-table-column align="center" prop="feeName" label="费用名称">
          </el-table-column>
          <el-table-column align="center" prop="amount" label="应收金额">
            <template slot-scope="scope">
              {{ scope.row.amount }}
              {{ scope.row.currency }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="arapTime" label="费用产生时间">
          </el-table-column>
        </el-table>

        <div>
          <el-pagination
            style="margin-top: 20px; float: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
          <div style="clear: both"></div>
        </div>

        <!-- 待支付状态显示 -->
        <div style="margin-top: 20px; float: right" v-if="basicData.id">
          <el-button
            v-if="basicData.state == 'C' || basicData.state == 'I'"
            @click="toPay(id, 'detail', totalAmount)"
            style="width: 120px"
            type="primary"
            >去支付</el-button
          >
          <el-button
            v-if="basicData.state != 'S'"
            @click="dialogVisible = true"
            style="width: 120px; color: #5f4aff"
            >上传水单</el-button
          >
          <el-button
            v-if="basicData.state == 'C' || basicData.state == 'I'"
            @click="invalid(basicData.state)"
            style="width: 120px"
            >废弃</el-button
          >
        </div>
      </el-card>

      <el-dialog
        :before-close="handleClose"
        title="图片上传"
        :visible.sync="dialogVisible"
        width="50%"
      >
        <div>
          <!-- <el-upload
            class="upload-demo"
            action="https://www.yt-buy.com/arap/uploadTransferVoucher"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :on-success="onSuccess"
            :data="iniData"
            :on-error="onError"
            :limit="6"
            :headers="headers"
            :on-exceed="handleExceed"
            :file-list="fileList"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload> -->

          <el-upload
            :on-preview="handlePreview"
            :on-success="onSuccess"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :on-change="onChange"
            :file-list="fileList"
            action="https://www.yundaomen.com.cn:8080/arap/uploadTransferVoucher"
            :limit="6"
            :headers="headers"
            :data="iniData"
            list-type="picture-card"
            ref="upload"
            :auto-upload="false"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <!-- <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleDownload(file)"
                >
                  <i class="el-icon-download"></i>
                </span> -->
                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>

          <el-button
            @click="upLoadPic()"
            style="margin-top: 10px"
            type="primary"
            size="mini"
            >确认上传</el-button
          >
          <span>最多上传九张，仅限JPG/JPEG/PNG格式</span>
          <el-dialog :modal="false" :visible.sync="dialogVisible1">
            <div style="text-algin: center">
              <div
                style="
                  zoom: 50%;
                  position: absolute;
                  opacity: 0.5;
                  width: 100%;
                  text-align: center;
                  z-index: 1;
                "
              >
                <el-button style="width: 100px" type="primary" @click="rotate()"
                  >旋转</el-button
                >
                <el-button
                  style="width: 100px"
                  type="primary"
                  @click="rotate('big')"
                  >放大</el-button
                >
                <el-button
                  style="width: 100px"
                  type="primary"
                  @click="rotate('small')"
                  >缩小</el-button
                >
              </div>
              <img
                ref="imgRef"
                style="width: 100%; height: 100%; max-height: 500px"
                :src="dialogImageUrl"
                alt=""
              />
            </div>
          </el-dialog>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      pageList: [],
      loading: false,
      iniData: {},
      headers: {},
      basicData: {},
      totalAmount: 0,
      id: "",
      tableData: [],
      status: "",
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisible1: false,
      disabled: false,
      fileList: [],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      deg: 90,
      scale: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rotate(type) {
      if (type == "big") {
        if (this.scale > 5) {
          this.$message.info("已经是最大了");
          return;
        }
        this.scale++;
        this.$refs.imgRef.style.transform = `rotate(${this.deg}deg) scale(1.${this.scale})`;

        return;
      }
      if (type == "small") {
        if (this.scale <= 0) {
          this.$message.info("已经是最小了");
          return;
        }
        this.scale--;
        this.$refs.imgRef.style.transform = `rotate(${this.deg}deg) scale(1.${this.scale})`;

        return;
      }

      if (this.deg >= 360) {
        this.deg = 0;
        this.deg += 90;
        this.$refs.imgRef.style.transform = `rotate(${this.deg}deg) scale(1.${this.scale})`;
      } else {
        this.deg += 90;
        this.$refs.imgRef.style.transform = `rotate(${this.deg}deg) scale(1.${this.scale})`;
      }
    },
    handleDownload(file) {
      console.log(file);
    },
    onSuccess(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      this.fileList = [];
      this.dialogImageUrl = "";
      this.dialogVisible = false;
      this.dialogVisible1 = false;
      this.$message.success("上传成功");
      console.log("success");
    },
    onChange(file, fileList) {
      console.log(file);
      console.log(fileList);
      this.fileList = fileList;
    },
    beforeUpload(file) {
      this.$message.info("上传中...");
      console.log(file);

      console.log("beforeUpload");
    },
    onError(err, file, fileList) {
      console.log(err);
      console.log(file);
      console.log(fileList);
      console.log("onError");
    },
    handleExceed(files, fileList) {
      //图片上传超过数量限制
      this.$message.error("上传图片不能超过6张!");
      console.log(file, fileList);
    },
    handleRemove(file) {
      this.fileList.forEach((v, index) => {
        if (v.uid == file.uid) {
          this.fileList.splice(index, 1);
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible1 = true;
      this.deg = 0;
      this.$refs.imgRef.style.transform = `rotate(${this.deg}deg)`;
    },
    //  废弃账单
    invalid(status) {
      // 待支付状态
      if (status == "I") {
        this.$confirm("此操作将作废此账单, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.axios
              .get("/arap/invalidFinaBill/" + this.iniData.id)
              .then((res) => {
                if (res.data.code == 200) {
                  // 成功后请求最新
                  this.$router.go(-1);
                  this.$message({
                    type: "success",
                    message: res.data.message,
                  });
                } else {
                  this.$message.info(res.data.message);
                }
              })
              .catch((res) => {
                console.log(res);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消作废此账单",
            });
          });
      } else {
        // 待确认状态
        this.$confirm("线下支付成功，财务核实水单中，是否废弃？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.axios
              .get("/arap/invalidFinaBill/" + this.iniData.id)
              .then((res) => {
                if (res.data.code == 200) {
                  // 成功后请求最新
                  this.$router.go(-1);
                  this.$message({
                    type: "success",
                    message: res.data.message,
                  });
                } else {
                  this.$message.info(res.data.message);
                }
              })
              .catch((res) => {
                console.log(res);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消作废此账单",
            });
          });
      }
    },
    // submitUpload(content) {
    //   const formData = new FormData();
    //   formData.append("media", content.file);
    //   const res = this.upLoadPic(content.file);
    //   console.log(res);
    // },
    handleSizeChange(val) {
      // 只要换页数就直接返回1页
      this.pageSize = val;
      this.currentPage = 1;
      this.pageList = this.tableData.slice(0, this.pageSize);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (val == 1) {
        this.pageList = this.tableData.slice(0, this.pageSize);
        return;
      }
      // 当前页 - 1 * 页数 = 分割开始数 比如二页 - 1  = 1*page
      val = (val - 1) * this.pageSize;
      // 分割结束数 = 分割开始数 + this.pageSize
      this.pageList = this.tableData.slice(val, val + this.pageSize);
    },
    handleClose(done) {
      this.fileList = [];
      done();
    },
    upLoadPic() {
      if (this.fileList.length > 10) {
        this.$message.info("最多上传九张！");
        return;
      }
      this.$message.info("上传中...");
      let imgfile = new FormData();
      for (var i = 0; i < this.fileList.length; i++) {
        imgfile.append("file", this.fileList[i].raw);
      }
      imgfile.append("billNo", this.iniData.billNo);
      imgfile.append("id", this.iniData.id);
      this.axios
        .post("/arap/uploadTransferVoucher", imgfile)
        .then((res) => {
          if (res.data.code == 200) {
            this.fileList = [];
            this.dialogImageUrl = "";
            this.dialogVisible = false;
            this.dialogVisible1 = false;
            this.$message.success("上传成功!");
          } else {
            this.$message.error(res.data.message || "上传失败，请重试!");
          }
        })
        .catch((res) => {
          this.$message.error("上传失败，请重试!");
        });
    },
    toPay(id, type, amount) {
      // 待支付状态
      if (this.status == "I") {
        this.$router.push({
          name: "payOrder",
          params: {
            id,
            amount: this.$route.query.amount,
            type,
          },
        });
      } else {
        // 待确认状态

        this.$confirm("线下支付成功，财务审核水单中，是否继续支付？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push({
              name: "payOrder",
              params: {
                id,
                amount: this.$route.query.amount,
                type,
              },
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },

    handlePreview(file) {
      console.log(file);
    },
    // 获取账单
    getList() {
      this.axios
        .get("/arap/getFinaBillWebSingleList/" + this.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.data.finaBillDetailList;
            this.total = this.tableData.length;
            this.basicData = res.data.data;
            this.pageList = this.tableData;

            if (this.tableData.length > 0) {
              let temp = JSON.stringify(this.tableData);
              this.pageList = JSON.parse(temp);

              this.pageList = this.pageList.slice(0, this.pageSize);
            }
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {});
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.iniData.id = this.$route.params.id;
      this.iniData.billNo = this.$route.params.billNo;
    } else {
      this.id = this.$route.query.id;
      this.iniData.id = this.$route.query.id;
      this.iniData.billNo = this.$route.query.billNo;
    }
    this.status = this.$route.query.state;

    let user = localStorage.getItem("Authorization_lineSupplier");
    user = JSON.parse(user);
    this.headers = {
      token: user.token,
    };
    console.log(this.$route.query);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList();
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/billType/PayDetail.vue